<div class="modal-header">
    <rask-header size="2">Arbetsordern har över 50 rader</rask-header>
</div>

<rask-container-block>
    Arbetsordern har mer än 50 rader. Vill du uppdatera virkesordern ändå, eller begränsa destineringsrader?
    <ng-container footer>
        <rask-button color="secondary" class="float-end" (click)="close(true)">Begränsa rader</rask-button>
        <rask-button color="primary" class="float-end" (click)="close(false)">Uppdatera virkesorder</rask-button>
    </ng-container>
</rask-container-block>